import React from 'react';
import { FileText, Users, DollarSign, Shield } from 'lucide-react';
import CTASection from '../../components/CTASection';
import ServiceHeroForm from '../../components/ServiceHeroForm';

const CopyrightLicensingPage = () => {
  return (
    <div>
      <div className="bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-5xl font-bold mb-6">Copyright <span className="text-[#168356]">Assignments & Licensing</span></h1>
            <p className="text-xl text-gray-300 max-w-3xl">Monetize your copyrights through strategic licensing agreements and properly structured assignments.</p>
          </div>
          <ServiceHeroForm title="Get Copyright Licensing Help" buttonText="Get Licensing Help" />
        </div>
      </div>
      <div className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto space-y-6 text-lg text-gray-700">
            <p>Copyright licensing allows you to generate revenue from your creative works while maintaining ownership. Whether granting exclusive rights to a publisher, licensing content to multiple users, or assigning rights permanently, proper legal documentation protects your interests.</p>
            <p>We draft and negotiate licensing agreements, assignments, work-for-hire contracts, and royalty arrangements. Our contracts clearly define scope of rights, territory, duration, compensation, and termination provisions to prevent future disputes.</p>
          </div>
        </div>
      </div>
      <div className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="bg-white rounded-xl p-6 text-center">
              <FileText className="w-12 h-12 text-[#168356] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">License Agreements</h3>
              <p className="text-gray-700 text-sm">Grant rights while maintaining ownership</p>
            </div>
            <div className="bg-white rounded-xl p-6 text-center">
              <Users className="w-12 h-12 text-[#168356] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Copyright Assignments</h3>
              <p className="text-gray-700 text-sm">Transfer ownership permanently with proper documentation</p>
            </div>
            <div className="bg-white rounded-xl p-6 text-center">
              <DollarSign className="w-12 h-12 text-[#168356] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Royalty Structures</h3>
              <p className="text-gray-700 text-sm">Design fair compensation arrangements</p>
            </div>
            <div className="bg-white rounded-xl p-6 text-center">
              <Shield className="w-12 h-12 text-[#168356] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Rights Protection</h3>
              <p className="text-gray-700 text-sm">Safeguard your interests in agreements</p>
            </div>
          </div>
        </div>
      </div>
      <CTASection />
    </div>
  );
};

export default CopyrightLicensingPage;